// Note - Browsers modified regex handling to include the /v flag, so need an updated syntax that includes 'useless escapes'

// eslint-disable-next-line no-useless-escape
export const PHONE_REGEX = /^[+]*\(?[0-9]{1,5}\)?[\-\s.\/0-9]{3,15}$/;

export const PHONE_REGEX_STRING = PHONE_REGEX.source;
